/**
 * Randomizes the products shown in the header mega-menu "featured products" panels.
 * Server renders a larger pool of products (per collection sort order); this script
 * shuffles that pool client-side and reveals a random subset on every page load /
 * every time a submenu panel is (re)hydrated, so visitors see a different selection.
 */

function shuffle(items) {
  for (let i = items.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }
  return items;
}

function applyReveal(ul) {
  const isTablet = window.matchMedia('(max-width: 989px)').matches;
  const desktopCount = parseInt(ul.dataset.revealCount, 10) || 1;
  const tabletCount = parseInt(ul.dataset.revealCountTablet, 10) || desktopCount;
  const count = isTablet ? tabletCount : desktopCount;

  Array.from(ul.children).forEach((li, index) => {
    if (index < count) {
      li.removeAttribute('hidden');
    } else {
      li.setAttribute('hidden', '');
    }
  });
}

function randomizeMenuPool(ul) {
  const items = shuffle(Array.from(ul.children));
  items.forEach((li) => ul.appendChild(li));
  applyReveal(ul);
}

function randomizeAllMenuPools(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-menu-random-pool]:not([data-randomized])').forEach((ul) => {
    ul.setAttribute('data-randomized', 'true');
    randomizeMenuPool(ul);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => randomizeAllMenuPools());
} else {
  randomizeAllMenuPools();
}

window.addEventListener('resize', () => {
  document.querySelectorAll('[data-menu-random-pool]').forEach(applyReveal);
});

const menuPoolObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes && mutation.addedNodes.length) {
      randomizeAllMenuPools(document);
      break;
    }
  }
});

menuPoolObserver.observe(document.documentElement, { childList: true, subtree: true });
